import { z } from "zod";

// @TODO(todd): Improve this schema.
export const shiftSchema = z.object({
  shiftID: z.string(),
  employeeID: z.string(),
  employeeCheckID: z.string(),
  first_name: z.string(),
  last_name: z.string(),
  time: z.string(),
});

export type Shift = z.infer<typeof shiftSchema>;
